module.exports = __webpack_public_path__ + "img/decoration-08.552e646.svg";